import gql from 'graphql-tag';

export const REMOVE_FROM_SENT_LIST = gql`
    mutation (
        $input: MarketingCampaignParticipantListInput!
        $marketingCampaignId: String!
    ) {
        removeFromSentList (
            input: $input
            marketingCampaignId: $marketingCampaignId
        )
    }
`;